import { create } from "zustand";
import { SoftwareSettingsMetadata } from "@domain/schemas/BI";

// functions as a place to store software settings in the form of lists.
// either prop files, json files or report Schemas.

interface SoftwareSettingsStore {
  // for all DirectDIA settings (this is both prop and json)
  settingsDirectDIAList: SoftwareSettingsMetadata[];
  setDirectDIASettingsList: (softwareSettingsList: SoftwareSettingsMetadata[]) => void;

  // for all reportSchema settings
  settingsReportSchemaList: SoftwareSettingsMetadata[];
  selectedReportSchemas?: SoftwareSettingsMetadata[];
  setReportSchemaSettingsList: (softwareSettingsList: SoftwareSettingsMetadata[]) => void;
  setSelectedReportSchemas: (selectedSettingsReportSchema: SoftwareSettingsMetadata[]) => void;
}

export const useSoftwareSettingsStore = create<SoftwareSettingsStore>((set) => ({
  // for all DirectDIA settings (this is both prop and json)
  settingsDirectDIAList: [],
  setDirectDIASettingsList: (softwareSettingsList) =>
    set(() => ({
      settingsDirectDIAList: softwareSettingsList,
    })),

  // for all reportSchema settings
  settingsReportSchemaList: [],
  setReportSchemaSettingsList: (softwareSettingsList) =>
    set(() => ({
      settingsReportSchemaList: softwareSettingsList,
    })),

  setSelectedReportSchemas: (selectedReportSchemas: SoftwareSettingsMetadata[]) => set({ selectedReportSchemas }),
}));
